import styled from '@emotion/styled';
import { casinoColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { DragIcon } from 'src/assets/new-icon/DragIcon';
import { mediaQuery } from 'src/assets/media-query-config';
import { ChevronIcon } from 'src/assets/new-icon/ChevronIcon';
import { LazyLoadingImg } from 'src/components/CmsLazyLoadingImage/LazyLoadingImg';

interface GameRowType {
    isDragged: boolean;
}

export const GameRowCategory = styled('div', { label: 'GameRowCategory' })<GameRowType>`
    align-items: center;
    background: ${casinoColors.bgColorGameRow};
    cursor:  ${({ isDragged }): string => isDragged ? 'grabbing' : 'grab'};
    display: flex;
    justify-content: space-between;
    padding: 12px 48px;
    position: relative;
    user-select: none;
    width: 100%;
`;

export const GameRowList = styled(GameRowCategory, { label: 'GameRowList' })`
    padding: 12px 24px;
    margin-bottom: 8px;
`;

export const DragGameIcon = styled(DragIcon, { label: 'DragGameIcon' })`
    cursor: grab;
    fill: ${casinoColors.iconColorGame};
    left: 14px;
    position: absolute;
`;

export const LeftSide = styled('div', { label: 'LeftSide' })`
    align-items: center;
    display: flex;
    flex: 0 0 50%;
`;

export const ImageWrapper = styled('div', { label: 'ImageWrapper' })`
    flex: 0 0 48px;
    height: 32px;
    overflow: hidden;
    pointer-events: none;
`;

export const ImagePlaceholder = styled('div', { label: 'ImagePlaceholder' })`
    background-color: ${casinoColors.disabledGray};
    align-items: center;
    color: ${casinoColors.white};
    display: flex;
    font-size: ${fontSize.xSmall};
    height: 32px;
    justify-content: center;
    line-height: 1;
    width: 48px;
`;

export const GameImageWrapperLazy = styled(LazyLoadingImg, { label: 'GameImageWrapperLazy' })`
    height: 32px;
    justify-content: center;
    line-height: 1;
    width: 48px;
`;

export const GameName = styled('div', { label: 'GameName' })`
    margin-left: 8px;
    color: ${casinoColors.txtColorGameName};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 16px;
    max-width: 100px;
    overflow: hidden;
    padding: 8px 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media ${mediaQuery.xLargeDesktop} {
        max-width: 120px;
    }
    @media ${mediaQuery.xxLargeDesktop} {
        max-width: 180px;
    }
`;

export const RightSideCategory = styled('div', { label: 'RightSideCategory' })`
    align-items: center;
    display: flex;
    flex: 0 0 50%;
    justify-content: space-between;
`;

export const RightSideList = styled(RightSideCategory, { label: 'RightSideList' })`
    flex: 0 0 50%;
`;

export const SupplierName = styled('div', { label: 'SupplierName' })`
    color: ${casinoColors.txtColorGameName};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.medium};
    line-height: 18px;
    opacity: .4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 60%;
    max-width: 80px;

    @media ${mediaQuery.largeDesktop} {
            max-width: 170px;
    }
`;

export const ChevronIconWrapper = styled('div', { label: 'ChevronIconWrapper' })`
    align-items: center;
    cursor: pointer;
    display: flex;
    flex: 0 0 56px;
    justify-content: center;
    margin: auto 0;
    position: absolute;
    right: 0;
    width: 50px;
`;

export const ChevronRight = styled(ChevronIcon, { label: 'ChevronRight' })`
    fill: ${casinoColors.iconColorGame};
`;
